/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Assumption } from '../model';
// @ts-ignore
import { AssumptionCategoryBasic } from '../model';
// @ts-ignore
import { AssumptionCategoryWithAssumptions } from '../model';
// @ts-ignore
import { AssumptionValue } from '../model';
// @ts-ignore
import { Category } from '../model';
// @ts-ignore
import { EntityAssumptionDetail } from '../model';
/**
 * AssumptionApi - axios parameter creator
 * @export
 */
export const AssumptionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Copies matching values from a source entity to a target
         * @param {number} sourceEntityId 
         * @param {number} targetEntityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyEntityValues: async (sourceEntityId: number, targetEntityId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceEntityId' is not null or undefined
            assertParamExists('copyEntityValues', 'sourceEntityId', sourceEntityId)
            // verify required parameter 'targetEntityId' is not null or undefined
            assertParamExists('copyEntityValues', 'targetEntityId', targetEntityId)
            const localVarPath = `/entity/entityAssumptions/copy?sourceEntityId={sourceEntityId}&targetEntityId={targetEntityId}`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sourceEntityId !== undefined) {
                localVarQueryParameter['sourceEntityId'] = sourceEntityId;
            }

            if (targetEntityId !== undefined) {
                localVarQueryParameter['targetEntityId'] = targetEntityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates an assumption value
         * @param {AssumptionValue} [assumptionValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAssumptionValue: async (assumptionValue?: AssumptionValue, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/entity/entityAssumptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assumptionValue, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a list of all assumptions for the org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAssumptions: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/entity/assumptions/assumptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a list of all assumption categories with assumptions for the current org
         * @param {number} entityType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssumptionCategoriesWithAssumptions: async (entityType: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('getAssumptionCategoriesWithAssumptions', 'entityType', entityType)
            const localVarPath = `/entity/assumptions/categories/assumptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a list of assumptions for entity type
         * @param {number} entityTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssumptions: async (entityTypeId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityTypeId' is not null or undefined
            assertParamExists('getAssumptions', 'entityTypeId', entityTypeId)
            const localVarPath = `/entity/assumptions/entityTypes/{entityTypeId}/assumptions`
                .replace(`{${"entityTypeId"}}`, encodeURIComponent(String(entityTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a list of assumption categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/entity/assumptions/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a list of project creation assumptions for entity type
         * @param {number} entityTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreationAssumptions: async (entityTypeId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityTypeId' is not null or undefined
            assertParamExists('getCreationAssumptions', 'entityTypeId', entityTypeId)
            const localVarPath = `/entity/assumptions/entityTypes/{entityTypeId}/creationAssumptions`
                .replace(`{${"entityTypeId"}}`, encodeURIComponent(String(entityTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a specific entity assumption value
         * @param {number} entityAssumptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAssumption: async (entityAssumptionId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityAssumptionId' is not null or undefined
            assertParamExists('getEntityAssumption', 'entityAssumptionId', entityAssumptionId)
            const localVarPath = `/entity/entityAssumptions/basic/{entityAssumptionId}`
                .replace(`{${"entityAssumptionId"}}`, encodeURIComponent(String(entityAssumptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a list of assumption values for an entity
         * @param {number} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAssumptions: async (entityId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getEntityAssumptions', 'entityId', entityId)
            const localVarPath = `/entity/entityAssumptions/entities/{entityId}/categories`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a specific entity assumption value detail
         * @param {number} entityAssumptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAssumtionDetail: async (entityAssumptionId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityAssumptionId' is not null or undefined
            assertParamExists('getEntityAssumtionDetail', 'entityAssumptionId', entityAssumptionId)
            const localVarPath = `/entity/entityAssumptions/detail/{entityAssumptionId}`
                .replace(`{${"entityAssumptionId"}}`, encodeURIComponent(String(entityAssumptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Saves an assumption value
         * @param {number} entityAssumptionId 
         * @param {AssumptionValue} [assumptionValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAssumptionValue: async (entityAssumptionId: number, assumptionValue?: AssumptionValue, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityAssumptionId' is not null or undefined
            assertParamExists('saveAssumptionValue', 'entityAssumptionId', entityAssumptionId)
            const localVarPath = `/entity/entityAssumptions/{entityAssumptionId}`
                .replace(`{${"entityAssumptionId"}}`, encodeURIComponent(String(entityAssumptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assumptionValue, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssumptionApi - functional programming interface
 * @export
 */
export const AssumptionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssumptionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Copies matching values from a source entity to a target
         * @param {number} sourceEntityId 
         * @param {number} targetEntityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyEntityValues(sourceEntityId: number, targetEntityId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyEntityValues(sourceEntityId, targetEntityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates an assumption value
         * @param {AssumptionValue} [assumptionValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAssumptionValue(assumptionValue?: AssumptionValue, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssumptionValue>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAssumptionValue(assumptionValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets a list of all assumptions for the org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAssumptions(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Assumption>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAssumptions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets a list of all assumption categories with assumptions for the current org
         * @param {number} entityType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssumptionCategoriesWithAssumptions(entityType: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssumptionCategoryWithAssumptions>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssumptionCategoriesWithAssumptions(entityType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets a list of assumptions for entity type
         * @param {number} entityTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssumptions(entityTypeId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Assumption>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssumptions(entityTypeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets a list of assumption categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategories(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssumptionCategoryBasic>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategories(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets a list of project creation assumptions for entity type
         * @param {number} entityTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCreationAssumptions(entityTypeId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Assumption>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCreationAssumptions(entityTypeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets a specific entity assumption value
         * @param {number} entityAssumptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityAssumption(entityAssumptionId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssumptionValue>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityAssumption(entityAssumptionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets a list of assumption values for an entity
         * @param {number} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityAssumptions(entityId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Category>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityAssumptions(entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets a specific entity assumption value detail
         * @param {number} entityAssumptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityAssumtionDetail(entityAssumptionId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityAssumptionDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityAssumtionDetail(entityAssumptionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Saves an assumption value
         * @param {number} entityAssumptionId 
         * @param {AssumptionValue} [assumptionValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveAssumptionValue(entityAssumptionId: number, assumptionValue?: AssumptionValue, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssumptionValue>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveAssumptionValue(entityAssumptionId, assumptionValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AssumptionApi - factory interface
 * @export
 */
export const AssumptionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssumptionApiFp(configuration)
    return {
        /**
         * 
         * @summary Copies matching values from a source entity to a target
         * @param {number} sourceEntityId 
         * @param {number} targetEntityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyEntityValues(sourceEntityId: number, targetEntityId: number, options?: any): AxiosPromise<void> {
            return localVarFp.copyEntityValues(sourceEntityId, targetEntityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates an assumption value
         * @param {AssumptionValue} [assumptionValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAssumptionValue(assumptionValue?: AssumptionValue, options?: any): AxiosPromise<AssumptionValue> {
            return localVarFp.createAssumptionValue(assumptionValue, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a list of all assumptions for the org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAssumptions(options?: any): AxiosPromise<Array<Assumption>> {
            return localVarFp.getAllAssumptions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a list of all assumption categories with assumptions for the current org
         * @param {number} entityType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssumptionCategoriesWithAssumptions(entityType: number, options?: any): AxiosPromise<Array<AssumptionCategoryWithAssumptions>> {
            return localVarFp.getAssumptionCategoriesWithAssumptions(entityType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a list of assumptions for entity type
         * @param {number} entityTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssumptions(entityTypeId: number, options?: any): AxiosPromise<Array<Assumption>> {
            return localVarFp.getAssumptions(entityTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a list of assumption categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories(options?: any): AxiosPromise<Array<AssumptionCategoryBasic>> {
            return localVarFp.getCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a list of project creation assumptions for entity type
         * @param {number} entityTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreationAssumptions(entityTypeId: number, options?: any): AxiosPromise<Array<Assumption>> {
            return localVarFp.getCreationAssumptions(entityTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a specific entity assumption value
         * @param {number} entityAssumptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAssumption(entityAssumptionId: number, options?: any): AxiosPromise<AssumptionValue> {
            return localVarFp.getEntityAssumption(entityAssumptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a list of assumption values for an entity
         * @param {number} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAssumptions(entityId: number, options?: any): AxiosPromise<Array<Category>> {
            return localVarFp.getEntityAssumptions(entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a specific entity assumption value detail
         * @param {number} entityAssumptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAssumtionDetail(entityAssumptionId: number, options?: any): AxiosPromise<EntityAssumptionDetail> {
            return localVarFp.getEntityAssumtionDetail(entityAssumptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Saves an assumption value
         * @param {number} entityAssumptionId 
         * @param {AssumptionValue} [assumptionValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAssumptionValue(entityAssumptionId: number, assumptionValue?: AssumptionValue, options?: any): AxiosPromise<AssumptionValue> {
            return localVarFp.saveAssumptionValue(entityAssumptionId, assumptionValue, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssumptionApi - object-oriented interface
 * @export
 * @class AssumptionApi
 * @extends {BaseAPI}
 */
export class AssumptionApi extends BaseAPI {
    /**
     * 
     * @summary Copies matching values from a source entity to a target
     * @param {number} sourceEntityId 
     * @param {number} targetEntityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssumptionApi
     */
    public copyEntityValues(sourceEntityId: number, targetEntityId: number, options?: any) {
        return AssumptionApiFp(this.configuration).copyEntityValues(sourceEntityId, targetEntityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates an assumption value
     * @param {AssumptionValue} [assumptionValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssumptionApi
     */
    public createAssumptionValue(assumptionValue?: AssumptionValue, options?: any) {
        return AssumptionApiFp(this.configuration).createAssumptionValue(assumptionValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a list of all assumptions for the org
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssumptionApi
     */
    public getAllAssumptions(options?: any) {
        return AssumptionApiFp(this.configuration).getAllAssumptions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a list of all assumption categories with assumptions for the current org
     * @param {number} entityType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssumptionApi
     */
    public getAssumptionCategoriesWithAssumptions(entityType: number, options?: any) {
        return AssumptionApiFp(this.configuration).getAssumptionCategoriesWithAssumptions(entityType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a list of assumptions for entity type
     * @param {number} entityTypeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssumptionApi
     */
    public getAssumptions(entityTypeId: number, options?: any) {
        return AssumptionApiFp(this.configuration).getAssumptions(entityTypeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a list of assumption categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssumptionApi
     */
    public getCategories(options?: any) {
        return AssumptionApiFp(this.configuration).getCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a list of project creation assumptions for entity type
     * @param {number} entityTypeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssumptionApi
     */
    public getCreationAssumptions(entityTypeId: number, options?: any) {
        return AssumptionApiFp(this.configuration).getCreationAssumptions(entityTypeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a specific entity assumption value
     * @param {number} entityAssumptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssumptionApi
     */
    public getEntityAssumption(entityAssumptionId: number, options?: any) {
        return AssumptionApiFp(this.configuration).getEntityAssumption(entityAssumptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a list of assumption values for an entity
     * @param {number} entityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssumptionApi
     */
    public getEntityAssumptions(entityId: number, options?: any) {
        return AssumptionApiFp(this.configuration).getEntityAssumptions(entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a specific entity assumption value detail
     * @param {number} entityAssumptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssumptionApi
     */
    public getEntityAssumtionDetail(entityAssumptionId: number, options?: any) {
        return AssumptionApiFp(this.configuration).getEntityAssumtionDetail(entityAssumptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Saves an assumption value
     * @param {number} entityAssumptionId 
     * @param {AssumptionValue} [assumptionValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssumptionApi
     */
    public saveAssumptionValue(entityAssumptionId: number, assumptionValue?: AssumptionValue, options?: any) {
        return AssumptionApiFp(this.configuration).saveAssumptionValue(entityAssumptionId, assumptionValue, options).then((request) => request(this.axios, this.basePath));
    }
}
